import { GenderEnum } from '../enums/genderEnum';

export const convertGenderToString = (value: any) => {
  switch (value) {
    case GenderEnum.OTHER:
      return 'Other';
    case GenderEnum.MALE:
      return 'Male';
    case GenderEnum.FEMALE:
      return 'Female';
    default:
      return '';
  }
};
